import { DIAGRAM_IMPORT_BUBBLE_TYPES } from './diagramImportConstants';

export function formatDiagramImportValue(value) {
  if (value === undefined || value === '') {
    return '0.0000';
  }

  const num = parseFloat(value);
  if (isNaN(num)) {
    return '0.0000';
  }

  return num.toFixed(4);
}

export function isImportableInspectionBubbleType(type) {
  return DIAGRAM_IMPORT_BUBBLE_TYPES.includes((type || '').toLowerCase());
}

export function getPreservedDiagramBubbles(bubbles) {
  return (bubbles || []).filter(
    (bubble) => !isImportableInspectionBubbleType(bubble.type)
  );
}

export function prepareBubbleForBulkSave(bubble) {
  const payload = { ...bubble };
  delete payload._id;
  delete payload.id;
  delete payload.version;
  return payload;
}

export function buildDiagramExportRows(taskBubbles) {
  const rows = [];

  taskBubbles.sort((a, b) => a.number - b.number);
  taskBubbles.forEach((task) => {
    let bubbleType = task.type.toLowerCase();

    if (!isImportableInspectionBubbleType(bubbleType)) {
      return;
    }

    if (task.lengthType === 'aligned') {
      bubbleType = 'aligned length';
    }

    rows.push({
      Label: task.number,
      'Bubble Type': bubbleType,
      Description: task.description,
      Unit: task.unit,
      'Expected Value': task.expectedValue,
      'Tolerance 1':
        task.type === 'runout' ? task.tolerance : task.positiveTolerance,
      'Tolerance 2': task.negativeTolerance,
      Positions:
        bubbleType === 'runout' && task.multipleMeasurements === false
          ? 1
          : task.measurementCount,
      Orientation: task.orientation,
    });
  });

  return rows;
}
